import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg组件
 
// register globally
// svg文件下引入svg格式icon
Vue.component('svg-icon', SvgIcon)
 
const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)


// WEBPACK FOOTER //
// ./src/icons/index.js